/* eslint-disable no-param-reassign */
class DataLayerController {
  constructor() {
    this.config = {
      moduleList: () => document.querySelectorAll('[data-module*="DataLayer"]')
    };
  }

  static mapDataLayer(data) {
    return data.map((item, i) => {
      const categories = {};
      item.Categories[0]
        .split('/')
        .filter(cat => cat !== '')
        .forEach((cat, index) => {
          const categoryName = `item_category_${index !== 0 ? index : ''}`;
          categories[categoryName] = cat;
        });
      let price = '-';
      let discount = '-';
      if (item.CurrentPrice) {
        price = item.CurrentPrice;
      }
      if (item.Discount !== undefined) {
        discount = item.Discount;
      }
      let page = 0;
      const isPaged = window.location.pathname.includes('/page/');

      if (isPaged) {
        const lastPathUrl = window.location.pathname.split('/').pop();
        page = (parseInt(lastPathUrl, 10) - 1) * 24;
      }
      const itemData = {
        item_id: item.Itemcode,
        item_name: item.Name,
        // affiliation: "Google Merchandise Store", //bij Van Lier niet noodzakelijk (kan gebruikt worden voor locatie)
        currency: 'EUR',
        discount,
        index: page + i + 1,
        item_brand: item.Brand,
        item_list_id: item.itemListId,
        item_list_name: item.itemListId,
        // location_id: "L_12345", //bij Van Lier niet noodzakelijk (kan gebruikt worden voor locatie - Place IDs uniquely identify a place in the Google Places database and on Google Maps)
        price,
        quantity: item.quantity || 1,
        ...categories
      };

      if (item.IsSale) {
        data.promotion_name = 'Sale';
      }

      return itemData;
    });
  }

  static setLoadDatalayer(data, type) {
    window.dataLayer.push({
      event: type,
      ecommerce: {
        items: DataLayerController.mapDataLayer(data)
      }
    });
  }

  static setClickDatalayer(data, type) {
    data.forEach(item => {
      if (!item.element.dataset.dlinitialized) return;
      item.element.dataset.dlinitialized = true;
      item.element.addEventListener('click', e => {
        if (['SVG', 'PATH'].includes(e.target.nodeName.toUpperCase())) return;
        window.dataLayer.push({
          event: type,
          ecommerce: {
            items: DataLayerController.mapDataLayer([item])
          }
        });
      });
    });
  }

  static handleDatalayerTypes(data) {
    if (data.load) {
      Object.keys(data.load).forEach(type => {
        DataLayerController.setLoadDatalayer(data.load[type], type);
      });
    }

    if (data.click) {
      Object.keys(data.click).forEach(type => {
        DataLayerController.setClickDatalayer(data.click[type], type);
      });
    }
  }

  static addToCart(element, quantity = 1) {
    const { layerName, layerData, layerListId } = element.dataset;
    const isArray = Array.isArray(JSON.parse(layerData));
    let data = isArray ? JSON.parse(layerData) : [JSON.parse(layerData)];
    if (isArray) {
      data = data.map(item => ({ ...item, itemListId: layerListId }));
    } else {
      data[0].itemListId = layerListId;
      data[0].quantity = parseInt(quantity, 10);
    }
    window.dataLayer.push({
      event: layerName,
      ecommerce: {
        items: DataLayerController.mapDataLayer(data)
      }
    });
  }

  static addToFavourites(element) {
    const { layerName, layerData, layerListId } = element.dataset;
    const data = { ...JSON.parse(layerData), itemListId: layerListId };
    window.dataLayer.push({
      event: layerName,
      ecommerce: {
        items: DataLayerController.mapDataLayer([data])
      }
    });
  }

  init() {
    const { moduleList } = this.config;
    const modules = moduleList();
    window.dataLayer.push({ ecommerce: null });

    if (modules.length > 0) {
      modules.forEach(_module => {
        const module = _module;
        const { dlinitialized } = module.dataset;

        if (dlinitialized) return;

        module.dataset.dlinitialized = true;
      });
      const sortedData = Array.from(modules).reduce((prev, curr) => {
        const { layerType, layerName, layerData, layerListId } = curr.dataset;
        const data = { ...JSON.parse(layerData), itemListId: layerListId, element: curr };
        if (layerType === '') return prev;

        prev[layerType] = prev[layerType] || {};
        prev[layerType][layerName] = prev[layerType][layerName] || [];
        prev[layerType][layerName].push(data);
        return prev;
      }, {});
      DataLayerController.handleDatalayerTypes(sortedData);
    }
  }
}

export default DataLayerController;
